module.exports = "<div class=\"all-page justify-content-center align-items-center\">\n    <i class=\"fas fa-spinner fa-pulse fa-3x\"></i>\n</div>"